import { FormInitializerReturnType } from 'src/Configuration/validation'
import { InviteFormType } from '../components/InviteEditor'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { object, string } from 'yup'

/**
 * Initializes the form for inviting a new user.
 * @returns initialValues and validationSchema for userInvite-form
 */
export const useInviteEditorFormInitializer = (): FormInitializerReturnType<InviteFormType, InviteFormType> => {
  const { t } = useCustomTranslation()
  const initialValues = { email: '' }
  const validationSchema = object().shape({
    email: string().email().required(t('validations.form.email.is-required')),
  })
  return { initialValues, validationSchema }
}
